import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as SavingBank } from '../../assets/images/svg/saving-bank.svg';
import themeColors from '../../assets/styles/themeColors';

const SavingBankStyled = styled(SavingBank)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorBackgroundSecondaryLight};
  stroke: ${themeColors.colorTextPrimary};

  circle {
    stroke: none;
  }
`;

const SavingBankIcon = (props) => <SavingBankStyled {...props} />;

SavingBankIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

SavingBankIcon.defaultProps = {
  w: '40px',
  h: '40px',
};

export default SavingBankIcon;
